import { useQuery } from '@tanstack/react-query';
import api from '../api/client';
import { DashboardStats } from '../types';

export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => {
      const response = await api.get<DashboardStats>('/dashboard');
      return response.data;
    },
    refetchInterval: 60000, // Refresh every minute
    staleTime: 30000, // Data is fresh for 30 seconds
  });
};
